exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pro_checkout_container[data-v-904598c8] {\n  padding: 1.5625rem;\n}\n@media (min-width: 1024px) {\n.pro_checkout_container[data-v-904598c8] {\n    margin: 0 auto;\n    max-width: 1600px;\n    padding: 0 60px 0 360px;\n    min-height: 100vh;\n}\n}\n@media screen and (min-width: 1900px) {\n.pro_checkout_container[data-v-904598c8] {\n    width: 1180px;\n    padding: 0;\n}\n}\n.pro_checkout_container .pro_checkout_header[data-v-904598c8] {\n  padding: 64px 0 35px 0;\n}\n.pro_checkout_container .opc[data-v-904598c8] {\n  padding-bottom: 44px;\n}\n", ""]);

// exports
